const pageNameKey = "adminPanelSidebar";

export const adminPanelSidebarEn = {
  [pageNameKey]: {
    admin: "Admin",
    organization: "Organizations",
    machineGroups: "Machine Groups",
    cleanup: "Cleanup",
    navigationLabel: "Admin Panel navigation",
  },
};

export const adminPanelSidebarPtBr = {
  [pageNameKey]: {
    admin: "Administração",
    organization: "Organizações",
    machineGroups: "Grupos de máquinas",
    cleanup: "Limpeza",
    navigationLabel: "Navegação do painel de administração",
  },
};

export const adminPanelSidebarDe = {
  [pageNameKey]: {
    admin: "Admin",
    organization: "Organisationen",
    machineGroups: "Maschinengruppen",
    cleanup: "Bereinigung",
    navigationLabel: "Admin-Panel-Navigation",
  },
};

export const adminPanelSidebarZhHans = {
  [pageNameKey]: {
    admin: "管理",
    organization: "组织",
    machineGroups: "机器组",
    cleanup: "清理",
    navigationLabel: "管理面板导航",
  },
};

export const adminPanelSidebarIt = {
  [pageNameKey]: {
    admin: "Amministrazione",
    organization: "Organizzazioni",
    machineGroups: "Gruppi di macchine",
    cleanup: "Pulizia",
    navigationLabel: "Navigazione del pannello di amministrazione",
  },
};

export const adminPanelSidebarEs = {
  [pageNameKey]: {
    admin: "Administración",
    organization: "Organizaciones",
    machineGroups: "Grupos de máquinas",
    cleanup: "Limpieza",
    navigationLabel: "Navegación del panel de administración",
  },
};

export const adminPanelSidebarNl = {
  [pageNameKey]: {
    admin: "Beheer",
    organization: "Organisaties",
    machineGroups: "Machinegroepen",
    cleanup: "Opschonen",
    navigationLabel: "Navigatie van het beheerpaneel",
  },
};

export const adminPanelSidebarTr = {
  [pageNameKey]: {
    admin: "Yönetici",
    organization: "Organizasyonlar",
    machineGroups: "Makine Grupları",
    cleanup: "Temizlik",
    navigationLabel: "Yönetim paneli navigasyonu",
  },
};
